import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listActions } from './types';
import { columnsToCamelCase, getColumnsRowMapObjectForExportFunc, ObjectType } from '@/main/utils/table';
import { forceFileDownload, localizeFileName, renameKeysForExportFunc } from '@/main/utils/fileHelper';

const filter = {
	StatusId: null as number | null,
	WarehouseId: null as number | null,
	Remark: null as string | null,
	IsBullkActive: false as boolean | false,	
	Uploaded_BulkInventory_Id: null as number | null,
	BulkInventoryPrp: null as boolean | null,
};
export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		StatusId: [],
		WarehouseId: [],
		BulkInventoryStatus: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {
		async [listActions.EXPORT_DATA]({ state }, headerData) {
			const tableData = [] as any;
			state.table.rows.forEach((row: any) => {
				const rowData = getColumnsRowMapObjectForExportFunc(columnsToCamelCase(state.table.columns.filter(x => x.isVisible === true)), row.cells, ObjectType.columnName, true);

				tableData.push(rowData);
			});
			const formattedTableData = tableData.map((row: any) => renameKeysForExportFunc(row));
			if (formattedTableData && formattedTableData.length > 0 && formattedTableData[0]) {
				const reportColumn = Object.keys(formattedTableData[0]);
				// Extract rows
				const reportRows = formattedTableData.map((row: Record<string, any>) => reportColumn.map(header => row[header] ?? ''));
				// Combine all rows
				const allRows = [...headerData, reportColumn, ...reportRows];
				const val = localizeFileName(state.crumb.label);

				// Convert to CSV string
				const csvContent = allRows.map((row: unknown[]) => row.map((cell: unknown) => `"${cell}"`).join(',')).join('\n');

				const url = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(csvContent)}`;
				return forceFileDownload(url, val);
			}

			return null;
		},
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		ReturnStatus: null as number | null,
		RejectedComments: '' as string,
		Remarks: null as string | null,
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
